import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Checkbox, Col, Flex, Form, Row, Tag, TimePicker } from 'antd';
import { BgWrapperEditorInput } from '../../editor/editor.style';
const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const LocationHours = ({ value, onSubmit, locationHoursModal, onValuesChange, }) => {
    const sunday = Form.useWatch(['Sunday'], locationHoursModal);
    const monday = Form.useWatch(['Monday'], locationHoursModal);
    const tuesday = Form.useWatch(['Tuesday'], locationHoursModal);
    const wednesday = Form.useWatch(['Wednesday'], locationHoursModal);
    const thursday = Form.useWatch(['Thursday'], locationHoursModal);
    const friday = Form.useWatch(['Friday'], locationHoursModal);
    const saturday = Form.useWatch(['Saturday'], locationHoursModal);
    const formValues = [
        sunday,
        monday,
        tuesday,
        wednesday,
        thursday,
        friday,
        saturday,
    ];
    return (_jsx(Form, { form: locationHoursModal, onFinish: onSubmit, layout: "vertical", initialValues: value, onValuesChange: onValuesChange, children: daysOfWeek.map((day, index) => {
            const { isOpen, is24Hours } = formValues[index] || {};
            return (_jsx(BgWrapperEditorInput, { style: { marginBottom: '10px' }, children: _jsxs(Row, { gutter: 20, align: "middle", children: [_jsxs(Col, { flex: "2", children: [_jsx(Form.Item, { name: [day, 'isOpen'], valuePropName: "checked", noStyle: true, children: _jsx(Checkbox, { children: day }) }), isOpen && (_jsx(Tag, { bordered: false, color: "success", children: "Open" }))] }), isOpen && (_jsxs(_Fragment, { children: [_jsx(Col, { children: _jsx(Form.Item, { style: { marginBottom: 0 }, name: [day, 'is24Hours'], valuePropName: "checked", children: _jsx(Checkbox, { children: "Open 24 Hours" }) }) }), _jsx(Col, { flex: "3", children: !is24Hours && (_jsx(Flex, { align: "center", gap: 10, children: _jsx(Form.Item, { style: { marginBottom: 0 }, rules: [{ required: true }], name: [day, 'timeRange'], children: _jsx(TimePicker.RangePicker, { placeholder: ['Opens at', 'Closes at'], format: "HH:mm" }) }) })) })] }))] }) }, day));
        }) }));
};
export default LocationHours;
